import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
const NoClaimsPage = _ref => {
  let {
    company,
    accountType
  } = _ref;
  return /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No previous claim groups", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: "/".concat(accountType, "/companies/add_claim_group/").concat(company.id_in_provider_system, "--").concat(company.number, "/companies/").concat(company.id)
  }, "Import Claim Group"))));
};
export default NoClaimsPage;